/**
 * lsgo-authentication URLs per environment — same hostname switch as the
 * other service URLs (config/axios.js): *-staging.lifeskillsgo.com → staging,
 * *.lifeskillsgo.com → production, anything else → local dev.
 *
 * The base URL is also the token issuer, so it must match lsgo-authentication's
 * ISSUER exactly (local: "localhost", not 127.0.0.1). Each redirect URI must be
 * registered on the lsgo-platform-web client in that environment.
 */
const { hostname } = window.location;
const isLifeskills = hostname.includes('lifeskillsgo.com');
const isStagingHost = isLifeskills && hostname.includes('-staging');

export const LSGO_AUTHENTICATION_BASE_URL = isLifeskills
    ? isStagingHost
        ? 'https://auth-staging.lifeskillsgo.com'
        : 'https://auth.lifeskillsgo.com'
    : 'http://localhost:3006';

/**
 * True on the production hosts (*.lifeskillsgo.com, not -staging), read at
 * call time. Browser-side testing overrides (utils/lsgoAuthEmbedSession.js
 * embedAuthEnabled) are off here.
 */
export function isProductionHost(host = window.location.hostname) {
    return host.includes('lifeskillsgo.com') && !host.includes('-staging');
}

export const LSGO_AUTHENTICATION_CLIENT_ID = 'lsgo-platform-web';

export const LSGO_AUTHENTICATION_REDIRECT_URI = isLifeskills
    ? isStagingHost
        ? 'https://teacher-staging.lifeskillsgo.com/auth/callback'
        : 'https://teacher.lifeskillsgo.com/auth/callback'
    : 'http://localhost:3000/auth/callback';
